export const BaseURL = process.env.REACT_APP_API_BASE_URL;
export const ContestToken = 'tzPAtOClmjeEED88+2dpblbzatuqMkSt7GMIwaOEp0HKxjBV5WvUQant61zmr3Kr';

export const isMock = () => {
    return (window as any)?.NaviScripts?.isBuild;
};
